/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Nav_ItemInputs */

const en_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const id_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ms_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ca_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const cs_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const da_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const de_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const et_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const es_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const fr_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const hr_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const it_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const lv_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const lt_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Premium“`)
};

const hu_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prémium`)
};

const nl_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const nb_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const pl_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const pt_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ro_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const sk_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const sl_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const fi_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const sv_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const vi_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const tr_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const el_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const bg_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум`)
};

const ru_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум-подписка`)
};

const sr_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const uk_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преміум`)
};

const ka_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const hi_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीमियम`)
};

const th_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

const ko_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄`)
};

const zh_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级版`)
};

const zh_tw_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高級版`)
};

const ja_premium_nav_item = /** @type {(inputs: Premium_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium`)
};

/**
* | output |
* | --- |
* | "Premium" |
*
* @param {Premium_Nav_ItemInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const premium_nav_item = /** @type {((inputs?: Premium_Nav_ItemInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Nav_ItemInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_premium_nav_item(inputs)
	if (locale === "ms") return ms_premium_nav_item(inputs)
	if (locale === "ca") return ca_premium_nav_item(inputs)
	if (locale === "cs") return cs_premium_nav_item(inputs)
	if (locale === "da") return da_premium_nav_item(inputs)
	if (locale === "de") return de_premium_nav_item(inputs)
	if (locale === "et") return et_premium_nav_item(inputs)
	if (locale === "es") return es_premium_nav_item(inputs)
	if (locale === "fr") return fr_premium_nav_item(inputs)
	if (locale === "hr") return hr_premium_nav_item(inputs)
	if (locale === "it") return it_premium_nav_item(inputs)
	if (locale === "lv") return lv_premium_nav_item(inputs)
	if (locale === "lt") return lt_premium_nav_item(inputs)
	if (locale === "hu") return hu_premium_nav_item(inputs)
	if (locale === "nl") return nl_premium_nav_item(inputs)
	if (locale === "nb") return nb_premium_nav_item(inputs)
	if (locale === "pl") return pl_premium_nav_item(inputs)
	if (locale === "pt") return pt_premium_nav_item(inputs)
	if (locale === "ro") return ro_premium_nav_item(inputs)
	if (locale === "sk") return sk_premium_nav_item(inputs)
	if (locale === "sl") return sl_premium_nav_item(inputs)
	if (locale === "fi") return fi_premium_nav_item(inputs)
	if (locale === "sv") return sv_premium_nav_item(inputs)
	if (locale === "vi") return vi_premium_nav_item(inputs)
	if (locale === "tr") return tr_premium_nav_item(inputs)
	if (locale === "el") return el_premium_nav_item(inputs)
	if (locale === "bg") return bg_premium_nav_item(inputs)
	if (locale === "ru") return ru_premium_nav_item(inputs)
	if (locale === "sr") return sr_premium_nav_item(inputs)
	if (locale === "uk") return uk_premium_nav_item(inputs)
	if (locale === "ka") return ka_premium_nav_item(inputs)
	if (locale === "hi") return hi_premium_nav_item(inputs)
	if (locale === "th") return th_premium_nav_item(inputs)
	if (locale === "ko") return ko_premium_nav_item(inputs)
	if (locale === "zh") return zh_premium_nav_item(inputs)
	if (locale === "zh-tw") return zh_tw_premium_nav_item(inputs)
	if (locale === "ja") return ja_premium_nav_item(inputs)
	return en_premium_nav_item(inputs)
});